<template>
    <div>
        <!-- import account -->
        <app-account></app-account>

        <!-- alerts contents -->
        <div class="container">
            <template v-if="myTransactions">
                <div class="row mt-2">
                    <div class="col-lg-3 col-md-4 col-sm-5 col-12 text-center text-sm-left">
                        <h4 class="d-block md-small-text">Transaction Logs</h4>
                    </div>
                    <div class="col-lg-9 col-md-8 col-sm-7 col-12 text-center text-sm-right pt-1">
                        <template v-if="countRecords">
                            Showing 
                            <select @change="modifyLimit(recordsLimit)" v-model="recordsLimit">
                                <option v-for="(x, i) in countRecords.steps" :key="i" :value="x">{{x}}</option>
                            </select> 
                            of {{countRecords.total}} records
                        </template>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12">
                        <!-- display transaction logs -->
                        <div class="table-responsive">
                            <table class="table table-hover mt-3">
                                <thead class="bg-silver">
                                    <tr>
                                        <th scope="col">No.</th>
                                        <th scope="col">Event</th>
                                        <th scope="col">Number</th>
                                        <th scope="col">Time</th>
                                        <th scope="col" class="text-center">View</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(transaction, i) in myTransactions" :key="transaction.id" @click="viewSingleTransaction(transaction.id)" class="clickable">
                                        <th scope="row">{{ i+1 }}.</th>
                                        <td><span class="text-truncate">{{transaction.event | capitalize}} </span></td>
                                        <td>{{transaction.number}}</td>
                                        <td><span class="text-truncate">{{transaction.joined | moment("MMM D 'YY")}}</span></td>
                                        <td class="text-center"><i class="fas fa-envelope-open-text text-dark-green"></i></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div class="row my-5">
                    <div class="col-12 text-muted">
                        <center>
                            <i class="fas fa-scroll fa-5x my-3"></i>
                            <h5>Hi {{user.name | capitalize}}, you don't have any transaction log yet.</h5>
                            <router-link :to="{ name: 'home' }" class="btn btn-dark-green my-5">
                                <i class="fas fa-smile"></i> Continue Shopping
                            </router-link>
                        </center>
                    </div>
                </div>
            </template>
        </div>

        <!-- view a selected transaction -->
        <app-transaction-details :transactionId="selectedId"></app-transaction-details>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { paginateRecords } from '@/store/dry'

import Account from '../shared/Account.vue'
import TransactionDetails from './transactionsParts/TransactionDetails.vue'
import LayoutUser from '@/layouts/User.vue'

export default {
    name: "Transactions",
    data() {
        return {
            selectedId: '',
            recordsLimit: 0,
        }
    },
    methods: {
        ...mapActions(['fetchTransactions']),
        viewSingleTransaction(transactionId) {
            this.selectedId = transactionId
        },
        modifyLimit(limit) {
            this.recordsLimit = limit
        }
    },
    computed: {
        ...mapGetters(['transactions', 'user']),
        myTransactions() {
            if(this.transactions && this.transactions !== null){
                return this.transactions.slice(0, this.recordsLimit)
            }
            return false
        },
        countRecords() {
            if(this.transactions && this.transactions.length){
                let resultObj = paginateRecords(this.transactions, 9)
                this.recordsLimit = resultObj.steps[0]
                return resultObj
            }
            return false
        }
    },
    components: {
        appAccount: Account,
        appTransactionDetails: TransactionDetails
    },
    created() {
        this.fetchTransactions().then(() => {}).catch((e) => {})
        this.$emit('update:layout', LayoutUser)
    }
}
</script>